import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import Link from 'next/link';
import { createStyles } from '@mantine/core';

import { useIsCanada } from '~/domains/common/hooks/useIsCanada';
import { Text } from '~/domains/design-system/Text';
import { Routes } from '~/domains/common/constants/routes';

const useStyles = createStyles((theme) => ({
  legalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    textAlign: 'left',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
    width: '100%',
  },
  legalText: {
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ '32px',
    fontSize: '12px',
    color: theme.colors.gray[5],

    '& > a': {
      color: theme.colors.blue[7],
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    [theme.fn.smallerThan('sm')]: {
      marginTop: 0,
    },
  },
}));

function SignUpLegal() {
  const { classes } = useStyles();
  const { t } = useTranslation('auth');
  const isCanada = useIsCanada();

  return (
    <div className={classes.legalContainer}>
      <Text className={classes.legalText}>
        <Trans
          i18nKey="auth:signUp.legalBlurbV2"
          components={{
            whereCanIPlayLink: (
              <Link href="https://splashsports.com/where-can-you-play" target="_blank">
                {t('signUp.whereCanIPlay')}
              </Link>
            ),
            termsLink: (
              <Link href={Routes.termsOfUse(isCanada)} target="_blank">
                {t('signUp.terms')}
              </Link>
            ),
            privacyLink: (
              <Link href={Routes.privacyPolicy(isCanada)} target="_blank">
                {t('signUp.privacyPolicy')}
              </Link>
            ),
          }}
        />
      </Text>
    </div>
  );
}

export default SignUpLegal;
